import { useCallback } from 'react';
import useWaApi from './axios/useWaApi';
import { User } from '../store/WaUserStore';
import { Workplace } from '../store/models/workplace';

export interface UsersBoxParameters {
  centerLat: number;
  centerLon: number;
  searchRange: number;
}

export interface UsersSearchParameters {
  name?: string;
  ldapId?: string;
  telephoneNumber?: string;
}

export interface UserReservationsParameters {
  disasterId: string;
}

function useWaUserRepo() {
  const { get } = useWaApi();

  const getUsersByLocationRequest = useCallback(
    async (parameters: UsersBoxParameters) => {
      try {
        return (
          (await get<User[]>('/api/wa/users', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  const getUsersByNameLdapPhoneNoRequest = useCallback(
    async (parameters: UsersSearchParameters) => {
      try {
        return (
          (await get<User[]>('/api/wa/users/search', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  const getCurrentUserReservations = useCallback(
    async (parameters: UserReservationsParameters) => {
      try {
        return (
          (await get<Workplace[]>('/api/wa/users/me/reservations', {
            params: parameters,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })) ?? []
        );
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    [get]
  );

  return {
    getUsersByLocationRequest,
    getUsersByNameLdapPhoneNoRequest,
    getCurrentUserReservations,
  };
}

export default useWaUserRepo;
